import PropTypes from 'prop-types';

import Box from '@mui/material/Box';
import TableRow from '@mui/material/TableRow';
import Checkbox from '@mui/material/Checkbox';
import TableHead from '@mui/material/TableHead';
import TableCell from '@mui/material/TableCell';
import TableSortLabel from '@mui/material/TableSortLabel';

import { useSettingsContext } from '../settings';

// ----------------------------------------------------------------------

const visuallyHidden = {
    border: 0,
    margin: -1,
    padding: 0,
    width: '1px',
    height: '1px',
    overflow: 'hidden',
    position: 'absolute',
    whiteSpace: 'nowrap',
    clip: 'rect(0 0 0 0)',
};

// ----------------------------------------------------------------------

export default function AutomationTableHeadCustom({
    order,
    orderBy,
    rowCount = 0,
    headLabel,
    numSelected = 0,
    onSort,
    onSelectAllRows,
    sx,
    stickyColumns = [], // NEW PROP
}) {
    const settings = useSettingsContext();

    // Define left offsets for sticky columns (adjust as needed)
    const stickyOffsets = [0, 62, 200, 350, 500, 650, 800, 950, 1100, 1250, 1400, 1550, 1700];

    return (
        <TableHead sx={sx}>
            <TableRow
                className={
                    settings?.themeMode === 'light'
                        ? 'automation-main-table-head'
                        : 'automation-main-table-head-custom'
                }
            >
                {onSelectAllRows && (
                    <TableCell padding="checkbox"
                        sx={stickyColumns.includes(1)
                            ? {
                                position: 'sticky',
                                left: stickyOffsets[0],
                                zIndex: 99,
                                backgroundColor: settings?.themeMode === 'light' ? '#ECF0F1' : '#333',
                                width: 62,
                            }
                            : { width: 62 }}
                    >
                        <Checkbox
                            indeterminate={!!numSelected && numSelected < rowCount}
                            checked={!!rowCount && numSelected === rowCount}
                            onChange={(event) => onSelectAllRows(event.target.checked)}
                        />
                    </TableCell>
                )}

                {headLabel.map((headCell, idx) => {
                    const colIndex = onSelectAllRows ? idx + 2 : idx + 1; // 1-based index, +1 if checkbox present
                    return (
                        <TableCell
                            key={headCell.id}
                            align={headCell.align || 'left'}
                            sortDirection={orderBy === headCell.id ? order : false}
                            sx={{
                                width: headCell.width,
                                minWidth: 140,
                                ...(stickyColumns.includes(colIndex)
                                    ? {
                                        position: 'sticky',
                                        left: stickyOffsets[colIndex - 1],
                                        zIndex: 98 - idx, // Decreasing zIndex for each sticky col
                                        backgroundColor: settings?.themeMode === 'light' ? '#ECF0F1' : '#333',
                                    }
                                    : {}),
                            }}
                        >
                            {onSort ? (
                                <TableSortLabel
                                    hideSortIcon
                                    active={orderBy === headCell.id}
                                    direction={orderBy === headCell.id ? order : 'asc'}
                                    onClick={() => onSort(headCell.id)}
                                    sx={{ fontSize: 13 }}
                                >
                                    {headCell.label}

                                    {orderBy === headCell.id ? (
                                        <Box sx={{ ...visuallyHidden }}>
                                            {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                        </Box>
                                    ) : null}
                                </TableSortLabel>
                            ) : (
                                headCell.label
                            )}
                        </TableCell>
                    );
                })}
            </TableRow>
        </TableHead>
    );
}

AutomationTableHeadCustom.propTypes = {
    sx: PropTypes.object,
    onSort: PropTypes.func,
    orderBy: PropTypes.string,
    headLabel: PropTypes.array,
    rowCount: PropTypes.number,
    numSelected: PropTypes.number,
    onSelectAllRows: PropTypes.func,
    order: PropTypes.oneOf(['asc', 'desc']),
    stickyColumns: PropTypes.array, // NEW PROP
}; 